import React from 'react';
import { Link } from 'react-router-dom';

function ErrorPage() {
  return (
    <>
      <div className='error'>
        <h1>Oops</h1>
        <p>We were unable to find the page you were looking for.</p>
        <Link to='/collection' className='btn'>
          Go Back Home
        </Link>
      </div>
    </>
  );
}

export default ErrorPage;
